import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Label } from '../../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import UpperCaseInput from '../../../components/UpperCaseInput';
import { RefreshCw } from 'lucide-react';

const StatusModal = ({
  isOpen,
  onClose,
  selectedDispatch,
  editData,
  setEditData,
  justification,
  setJustification,
  onSubmit
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Cambiar Estado - {selectedDispatch?.dispatch_number}</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="bg-slate-50 border border-slate-200 rounded-md p-4">
            <p className="text-sm text-slate-600 mb-2">Estado actual:</p>
            <span className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${
              selectedDispatch?.status === 'Pendiente' ? 'bg-yellow-100 text-yellow-800' :
              selectedDispatch?.status === 'En Proceso' ? 'bg-blue-100 text-blue-800' :
              'bg-green-100 text-green-800'
            }`}>
              {selectedDispatch?.status}
            </span>
          </div>
          
          <div className="space-y-2">
            <Label>Cambiar a:</Label>
            <Select value={editData.status} onValueChange={(v) => setEditData({ ...editData, status: v })}>
              <SelectTrigger><SelectValue placeholder="Seleccionar nuevo estado" /></SelectTrigger>
              <SelectContent>
                {selectedDispatch?.status === 'Pendiente' && (
                  <SelectItem value="En Proceso">En Proceso</SelectItem>
                )}
                {selectedDispatch?.status === 'En Proceso' && (
                  <SelectItem value="Finalizado">Finalizado</SelectItem>
                )}
                {selectedDispatch?.status === 'Finalizado' && (
                  <SelectItem value="En Proceso">En Proceso (Reabrir)</SelectItem>
                )}
              </SelectContent>
            </Select>
          </div>
          
          {selectedDispatch?.status === 'Finalizado' && editData.status === 'En Proceso' && (
            <div className="space-y-2">
              <Label className="text-red-600">Justificación (obligatoria para reabrir) *</Label>
              <UpperCaseInput 
                value={justification} 
                onChange={(e) => setJustification(e.target.value)} 
                required 
                placeholder="Motivo para reabrir el despacho" 
              />
            </div>
          )}
          
          <Button 
            type="submit" 
            className="w-full bg-purple-600 hover:bg-purple-700 text-white"
            disabled={!editData.status || editData.status === selectedDispatch?.status}
          >
            <RefreshCw size={16} className="mr-2" /> Cambiar Estado
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default StatusModal;
